/**
 * @fileoverview POST handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/launch" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdLaunchCacheKeys } from "./constants";
import type {
  PostDecisioningStudioAgentsAppGroupIdDsaIdLaunchError,
  PostDecisioningStudioAgentsAppGroupIdDsaIdLaunchProps,
  PostDecisioningStudioAgentsAppGroupIdDsaIdLaunchResult,
} from "./types";

export const postDecisioningStudioAgentsAppGroupIdDsaIdLaunch = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdLaunchCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostDecisioningStudioAgentsAppGroupIdDsaIdLaunchError>()(
    (
      props: PostDecisioningStudioAgentsAppGroupIdDsaIdLaunchProps
    ): Promise<PostDecisioningStudioAgentsAppGroupIdDsaIdLaunchResult> => {
      return fetch(
        `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/launch`,
        "POST",
        undefined,
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
